import Events from '@rover/utilities/events';
import $ from '@rover/globals/jquery';
import Authenticated from './Authenticated';

$(() => {
  Authenticated.init();
  Events.init();
});



// WEBPACK FOOTER //
// ./js/header.js